<template>
  <div class="table-responsive">
    <table class="table table-flush">
      <thead class="thead-light">
        <tr>
          <!--<th>Logo</th>-->
          <th>Name</th>
          <th>Type</th>
          <th>ID</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!organizations[0]">
          <td align="center" colspan="100%">No organizations found</td>
        </tr>
        <tr v-for="org of organizations" :key="org.id">
          <!--<td><img
            class="img-fluid rounded"  
              height="40px"
              :src="getImageUrl(org.id)"
            /></td> -->
          <td>{{ org.name }}</td>
          <td>{{ org.type }}</td>
          <td>{{ org.id }}</td>
          <td class="text-center">
            <!--<button
              data-toggle="modal"
              data-target="#editOrg"
              @click="editingOrg = org"
              type="button"
              class="btn btn-sm btn-dark btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-pen"></i>
            </button> -->
            <button
              @click="deleteOrg(org)"
              type="button"
              class="btn btn-sm btn-danger btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-trash"></i>
            </button>
            <button
              @click="simulateOrg(org)"
              type="button"
              class="btn btn-sm btn-primary btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-eye"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
        </tr>
      </tbody>
    </table>

    <!-- Start Modal -->
    <!--<div
      class="modal fade"
      id="editOrg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit Organization</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <edit-org-form :org="editingOrg" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- End Modal -->
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

import swal from "sweetalert2";

export default {
  name: "orgs-table",
  props: {
    organizations: Array
  },
  data() {
    return {
      editingOrg: {}
    };
  },
  methods: {
    formatDate(date) {
      if (date) {
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        const dateObj = new Date(date.seconds * 1000);

        const month = monthNames[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();

        return `${month} ${day}, ${year}`;
      }

      return "No date set";
    },
    getImageUrl(orgId) {
      const base =
        "https://firebasestorage.googleapis.com/v0/b/potential-5635b.appspot.com/o/";
      return `${base}organizations%2F${orgId}%2Fimages%2Fprofile_100x100.png?alt=media`;
    },
    hasRoles: function(roles) {
      return roles.every(this.hasRole);
    },
    hasRole: function(role) {
      return this.rolesData[role] != null || this.isOwner;
    },
    simulateOrg: function(org) {
      this.$store.commit("setCurOrg", org);

    },
    deleteOrg(org) {
      const curOrgId = this.curOrg.id;
      const self = this;

      swal
        .fire({
          title: "Are you sure?",
          text: `You are about to delete ${org.name}!`,
          type: "warning",
          icon: "warning",
          showCancelButton: !0,
          confirmButtonColor: "#0CC27E",
          cancelButtonColor: "#FF586B",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonClass: "btn btn-success mr-5",
          cancelButtonClass: "btn btn-danger",
          buttonsStyling: !1
        })
        .then(
          function(result) {
            if (result.value) {
              firebase
                .firestore()
                .doc(`organizations/${curOrgId}/potentialees/${potentialee.id}`)
                .delete()
                .then(() => location.reload())
                .catch(function(error) {
                  console.error(error);
                });
            }
          },
          function(t) {
            "cancel" === t &&
              swal("Cancelled", "Your file is safe :)", "error");
          }
        );
    }
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
    rolesData() {
      return this.$store.state.usermain.rolesData;
    }
  }
};
</script>
